import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0058185d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "first_title" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "flex-bwn statistics" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "100,000+", -1))
const _hoisted_5 = { class: "name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, "100,000,000+", -1))
const _hoisted_7 = { class: "name" }
const _hoisted_8 = {
  key: 0,
  class: "part3 flex-bwn"
}
const _hoisted_9 = { class: "left" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "flex-ter" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/client/login_h5_icon_mail.png",
  alt: ""
}, null, -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-right":"0"},
  src: "https://static-jp.theckb.com/static-asset/client/login_h5_icon_right.png",
  alt: ""
}, null, -1))
const _hoisted_16 = {
  key: 1,
  href: "tel:03-4446-7313",
  class: "phone"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-ter" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-jp.theckb.com/static-asset/client/login_h5_icon_phone.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, " 03-4446-7313 ")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-right":"0"},
  src: "https://static-jp.theckb.com/static-asset/client/login_h5_icon_right.png",
  alt: ""
}, null, -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  href: "https://line.me/R/ti/p/@962puoaf?oat_content=url",
  target: "_blank",
  class: "line"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flex-ter" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-jp.theckb.com/static-asset/client/login_h5_icon_line.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, " LINE友だち追加 ")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-right":"0"},
  src: "https://static-jp.theckb.com/static-asset/client/login_h5_icon_right.png",
  alt: ""
}, null, -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { class: "right" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 無料相談を")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" ご希望の場合 ")
const _hoisted_29 = {
  key: 1,
  style: {"text-align":"center","margin-bottom":"24px"}
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" If you need free consultation, ")
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode("please contact us ")
const _hoisted_34 = [
  _hoisted_31,
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { key: 2 }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 무료 상담 필요하시면")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 연락주시기 바랍니다 ")
const _hoisted_39 = [
  _hoisted_36,
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = { key: 3 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/login/sign_left_arrow.png",
  alt: ""
}, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "part1 part" }
const _hoisted_44 = { class: "subTitle" }
const _hoisted_45 = { class: "content" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clothes flex-bwn" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/Client/login/sign_cloth_1.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/Client/login/sign_cloth_2.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/Client/login/sign_cloth_3.png",
    alt: ""
  })
], -1))
const _hoisted_49 = { class: "barands" }
const _hoisted_50 = ["src"]
const _hoisted_51 = { class: "part2" }
const _hoisted_52 = { class: "subTitle" }
const _hoisted_53 = { class: "reasons" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "https://static-s.theckb.com/BusinessMarket/Client/login/sign_true_1.png",
  alt: ""
}, null, -1))
const _hoisted_55 = { class: "vipTips" }
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" 今すぐ登録して、")
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "free" }, "初月無料", -1))
const _hoisted_58 = /*#__PURE__*/_createTextVNode("でスタンダード会員を体験！ ")
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" 가입 후 즐거운 쇼핑 시간 되세요 ")
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Enjoy shopping after signing up for ")
const _hoisted_61 = {
  key: 1,
  class: "part3 flex-bwn"
}
const _hoisted_62 = { class: "left" }
const _hoisted_63 = { class: "content" }
const _hoisted_64 = ["href"]
const _hoisted_65 = { class: "flex-ter" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-jp.theckb.com/static-asset/client/login_h5_icon_mail.png",
  alt: ""
}, null, -1))
const _hoisted_67 = { key: 0 }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-right":"0"},
  src: "https://static-jp.theckb.com/static-asset/client/login_h5_icon_right.png",
  alt: ""
}, null, -1))
const _hoisted_69 = {
  key: 1,
  class: "phone"
}
const _hoisted_70 = {
  key: 2,
  class: "phone"
}
const _hoisted_71 = { class: "right" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" If you need free consultation, ")
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_75 = /*#__PURE__*/_createTextVNode("please contact us ")
const _hoisted_76 = [
  _hoisted_73,
  _hoisted_74,
  _hoisted_75
]
const _hoisted_77 = { key: 1 }
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" 무료 상담 필요하시면")
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" 연락주시기 바랍니다 ")
const _hoisted_81 = [
  _hoisted_78,
  _hoisted_79,
  _hoisted_80
]
const _hoisted_82 = { key: 2 }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/login/sign_left_arrow.png",
  alt: ""
}, null, -1))
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = {
  key: 2,
  class: "part4"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "location" }, [
  /*#__PURE__*/_createTextVNode(" サンプルショールーム："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 〒151-0051 東京都渋谷区千駄ケ谷１丁目２４−５ ")
], -1))
const _hoisted_87 = ["width", "height"]


import { isKO, isEN, isJA } from '@/store';
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: ['h5'],
  setup(__props) {



const reasons = [
  '通过多样化的采购渠道，提供丰富多样的商品阵容。',
  '日本标准的严格检验，品质有保障。',
  '通过自有OEM工厂支持品牌创建',
  '独自開発のシステムで仕入れ〜出荷を効率化'
]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["signup-lt", {
    'h5': __props.h5
  }])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('从策划提案到采购、OEM/ODM、质量管理、物流等全流程，提供一站式全方位支持。')), 1),
    _createElementVNode("div", {
      class: "main_title",
      innerHTML: _unref(t)('海外からの輸入・仕入れ・OEMならTHE CKB（直行便）')
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('用户数')), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('商品数')), 1)
      ])
    ]),
    (_unref(isJA)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('电话联系时间')), 1),
            (!_unref(isEN)())
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: `mailto:${_unref(isJA)() ? 'info@theckb.com' : 'info@sniffkorea.com'}`,
                  class: "email"
                }, [
                  _createElementVNode("span", _hoisted_12, [
                    _hoisted_13,
                    (_unref(isJA)())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "info@theckb.com"))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_15
                ], 8, _hoisted_11))
              : _createCommentVNode("", true),
            (_unref(isJA)())
              ? (_openBlock(), _createElementBlock("a", _hoisted_16, _hoisted_19))
              : _createCommentVNode("", true),
            (_unref(isJA)())
              ? (_openBlock(), _createElementBlock("a", _hoisted_20, _hoisted_23))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_unref(isJA)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (!__props.h5)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_26,
                        _hoisted_27,
                        _hoisted_28
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_29, "無料相談をご希望の場合"))
                ]))
              : _createCommentVNode("", true),
            (_unref(isEN)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_34))
              : _createCommentVNode("", true),
            (_unref(isKO)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_39))
              : _createCommentVNode("", true),
            (!__props.h5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(t)('什么是直行便')), 1),
      _createElementVNode("div", _hoisted_45, [
        _createTextVNode(_toDisplayString(_unref(t)('专注于海外商品批发采购及OEM生产的全方位采购服务。')), 1),
        _hoisted_46,
        _createTextVNode(" " + _toDisplayString(_unref(t)('通过线上线下双渠道确保高质量且低成本的采购渠道，依托自有OEM工厂、物流网络及专有系统，实现从订单下达至交付的全流程高效运作。')) + " ", 1),
        _hoisted_47,
        _createTextVNode(" " + _toDisplayString(_unref(t)('不仅优化日常采购流程，更全程支持原创品牌创建，致力于为客户实现利益最大化。')), 1)
      ]),
      _hoisted_48,
      _createElementVNode("div", _hoisted_49, [
        (_unref(isJA)())
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: __props.h5 ? 'https://static-s.theckb.com/BusinessMarket/Client/login/sign_brands_h5.png' : 'https://static-s.theckb.com/BusinessMarket/Client/login/sign_brands.png',
              alt: ""
            }, null, 8, _hoisted_50))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(t)('选择CKB的理由')), 1),
      _createElementVNode("div", _hoisted_53, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reasons, (item, idx) => {
          return _createElementVNode("div", {
            class: "reason flex-ter",
            key: idx
          }, [
            _hoisted_54,
            _createTextVNode(" " + _toDisplayString(_unref(t)(item)), 1)
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_55, [
      (_unref(isJA)())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_56,
            _hoisted_57,
            _hoisted_58
          ], 64))
        : _createCommentVNode("", true),
      (_unref(isKO)())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_59
          ], 64))
        : _createCommentVNode("", true),
      (_unref(isEN)())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_60
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (!_unref(isJA)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, _toDisplayString(_unref(t)('电话联系时间')), 1),
            (_unref(isKO)())
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: `mailto:info@sniffkorea.com`,
                  class: "email"
                }, [
                  _createElementVNode("span", _hoisted_65, [
                    _hoisted_66,
                    (_unref(isKO)())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_67, "info@sniffkorea.com"))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_68
                ], 8, _hoisted_64))
              : _createCommentVNode("", true),
            (_unref(isKO)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, " 카카오톡 채널 아이디: theckb "))
              : _createCommentVNode("", true),
            (_unref(isEN)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, " Echat(Customer service software in the system) "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_71, [
            (_unref(isEN)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, _hoisted_76))
              : _createCommentVNode("", true),
            (_unref(isKO)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_77, _hoisted_81))
              : _createCommentVNode("", true),
            (!__props.h5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_82, _hoisted_84))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(isJA)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
          _hoisted_86,
          _createElementVNode("iframe", {
            src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.8927294145806!2d139.7063133751131!3d35.6796432300623!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cbf07dad7f5%3A0x6e240aea6dc6bd7d!2z44CSMTUxLTAwNTEg5p2x5Lqs6YO95riL6LC35Yy65Y2D6aeE44Kx6LC377yR5LiB55uu77yS77yU4oiS77yVIOOCueODiOODvOODs-ODj-OCpuOCuSDvvJI!5e0!3m2!1sja!2sjp!4v1750317479645!5m2!1sja!2sjp",
            width: !__props.h5 ? 600 : 320,
            height: !__props.h5 ? 385 : 195,
            style: {"border":"0"},
            allowfullscreen: "true",
            loading: "lazy",
            referrerpolicy: "no-referrer-when-downgrade"
          }, null, 8, _hoisted_87)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})